import { render, staticRenderFns } from "./PaymentCard.vue?vue&type=template&id=6fa6de22&scoped=true&"
import script from "./PaymentCard.vue?vue&type=script&lang=js&"
export * from "./PaymentCard.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCard.vue?vue&type=style&index=0&id=6fa6de22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa6de22",
  null
  
)

export default component.exports